















































import { Component, Vue } from 'vue-property-decorator'
import http from '@/utils/http'

@Component({
  components: {
  }
})
export default class Login extends Vue {

  private email = ''
  private password = ''
  private showPassword = false

  public login() {
    this.$store.dispatch('login', { email: this.email, password: this.password})
  }

  public signup() {
    this.$router.push('signup')
  }

  public forgotPassword() {
    this.$router.push('forgot')
  }

  get message() {
    return this.$store.state.loginError
  }

}
